var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuestionCircled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1698_4816)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 0.5C4.47301 0.5 0 4.9725 0 10.5C0 16.0269 4.4725 20.5 10 20.5C15.527 20.5 20 16.0275 20 10.5C20 4.97301 15.5275 0.5 10 0.5ZM10 19.1046C5.25539 19.1046 1.39535 15.2446 1.39535 10.5C1.39535 5.75535 5.25539 1.89535 10 1.89535C14.7446 1.89535 18.6046 5.75535 18.6046 10.5C18.6046 15.2446 14.7446 19.1046 10 19.1046Z",
    fill: "#2667B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.70352 13.1519C9.15066 13.1519 8.70312 13.6126 8.70312 14.1654C8.70312 14.7051 9.1375 15.179 9.70352 15.179C10.2695 15.179 10.717 14.7051 10.717 14.1654C10.717 13.6126 10.2563 13.1519 9.70352 13.1519Z",
    fill: "#2667B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.87437 5.48022C8.09734 5.48022 7.28125 6.53331 7.28125 7.24409C7.28125 7.75745 7.71563 7.9944 8.07102 7.9944C8.78184 7.9944 8.49227 6.98081 9.83488 6.98081C10.493 6.98081 11.0196 7.27042 11.0196 7.87593C11.0196 8.58671 10.2824 8.99476 9.84805 9.36331C9.46629 9.69233 8.96613 10.2321 8.96613 11.3641C8.96613 12.0485 9.15043 12.246 9.69008 12.246C10.335 12.246 10.4667 11.9564 10.4667 11.7063C10.4667 11.0218 10.4798 10.6269 11.2038 10.0609C11.5592 9.78452 12.678 8.8894 12.678 7.6521C12.678 6.41479 11.5592 5.48022 9.87437 5.48022Z",
    fill: "#2667B0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1698_4816"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionCircled);
export default __webpack_public_path__ + "static/media/question_circled.4a30a0197f449afe3ef9e697e836edac.svg";
export { ForwardRef as ReactComponent };